import React, { useEffect } from 'react';

const IntroducerPage = () => {
  useEffect(() => {
    // Set body background to white and remove any margins/padding
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.backgroundColor = '#FFFFFF';
    document.body.style.overflow = 'hidden';

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      margin: 0, 
      padding: 0,
      overflow: 'hidden'
    }}>
      <iframe 
        src="https://differentiaform.fillout.com/t/87U26Pcw8qus"
        style={{
          width: '100%',
          height: '100vh',
          border: 0,
          margin: 0,
          padding: 0,
          display: 'block'
        }}
        frameBorder="0"
        allowFullScreen
        title="Introducer Form"
      />
    </div>
  );
};

export default IntroducerPage;
